import { queryOptions, useQuery } from "@tanstack/react-query";
import { apiWithoutCamelization } from "../../../../api";
import type { ActiveUser } from "../../../UserManagement/UserManagement.types";
import { expressOnboardingApi } from "../../api/expressOnboardingApi";
import type { ExpressOnboardingGeneratorsTableSiteTodoStatus } from "../../ExpressOnboarding.types";

export const expressOnboardingTodoQueries = {
  status: (userId: ActiveUser["id"] | null) =>
    queryOptions({
      queryKey: expressOnboardingApi.siteTodoStatus.key(userId),
      queryFn: async () => {
        const response = await apiWithoutCamelization.get<
          Array<ExpressOnboardingGeneratorsTableSiteTodoStatus>
        >(expressOnboardingApi.siteTodoStatus.url(userId));
        return response.data;
      }
    })
};

function useExpressOnboardingTodoStatus(userId: ActiveUser["id"] | null) {
  return useQuery(expressOnboardingTodoQueries.status(userId));
}

export { useExpressOnboardingTodoStatus };
